// Static navigation model for the Explore menu (mirrors seeded content slugs)
export const EXPLORE_GROUPS = [
  {
    id: "varieties",
    to: "/varieties",
    label: { ar: "أصناف التمور", en: "Varieties" },
    items: [
      { slug: "ajwa", to: "/varieties/ajwa", label: { ar: "العجوة", en: "Ajwa" } },
      { slug: "khalas", to: "/varieties/khalas", label: { ar: "الخلاص", en: "Khalas" } },
      { slug: "sukkari", to: "/varieties/sukkari", label: { ar: "السكري", en: "Sukkari" } },
      { slug: "safawi", to: "/varieties/safawi", label: { ar: "الصفوي", en: "Safawi" } },
      { slug: "barhi", to: "/varieties/barhi", label: { ar: "البرحي", en: "Barhi" } },
      { slug: "khudri", to: "/varieties/khudri", label: { ar: "الخضري", en: "Khudri" } },
      { slug: "segai", to: "/varieties/segai", label: { ar: "الصقعي", en: "Segai" } },
      { slug: "anbara", to: "/varieties/anbara", label: { ar: "العنبرة", en: "Anbara" } },
      { slug: "mabroom", to: "/varieties/mabroom", label: { ar: "المبروم", en: "Mabroom" } },
      { slug: "barni", to: "/varieties/barni", label: { ar: "البرني", en: "Barni" } },
      { slug: "rothana", to: "/varieties/rothana", label: { ar: "الروثانة", en: "Rothana" } },
      { slug: "shishi", to: "/varieties/shishi", label: { ar: "الشيشي", en: "Shishi" } },
      { slug: "ruzeiz", to: "/varieties/ruzeiz", label: { ar: "الرزيز", en: "Ruzeiz" } },
      { slug: "sullaj", to: "/varieties/sullaj", label: { ar: "الصلج", en: "Sullaj" } },
      { slug: "helwat-al-jouf", to: "/varieties/helwat-al-jouf", label: { ar: "حلوة الجوف", en: "Helwat Al-Jouf" } },
      { slug: "bayadh", to: "/varieties/bayadh", label: { ar: "البياض", en: "Bayadh" } },
    ],
  },
  {
    id: "oases",
    to: "/oases",
    label: { ar: "الواحات والمدن", en: "Oases & Cities" },
    items: [
      { slug: "al-ahsa", to: "/oases/al-ahsa", label: { ar: "الأحساء", en: "Al-Ahsa" } },
      { slug: "al-qassim", to: "/oases/al-qassim", label: { ar: "القصيم", en: "Al-Qassim" } },
      { slug: "al-madinah", to: "/oases/al-madinah", label: { ar: "المدينة المنورة", en: "Al-Madinah" } },
      { slug: "alula", to: "/oases/alula", label: { ar: "العلا", en: "AlUla" } },
      { slug: "bisha", to: "/oases/bisha", label: { ar: "بيشة", en: "Bisha" } },
    ],
  },
  {
    id: "regions",
    to: "/regions",
    label: { ar: "مناطق التمور", en: "Regions" },
    items: [
      { slug: "alahsa", to: "/regions/alahsa", label: { ar: "الأحساء", en: "Al-Ahsa" } },
      { slug: "qassim", to: "/regions/qassim", label: { ar: "القصيم", en: "Al-Qassim" } },
      { slug: "madinah", to: "/regions/madinah", label: { ar: "المدينة المنورة", en: "Al-Madinah" } },
      { slug: "riyadh", to: "/regions/riyadh", label: { ar: "الرياض وسدير", en: "Riyadh & Sudair" } },
      { slug: "najran", to: "/regions/najran", label: { ar: "نجران", en: "Najran" } },
      { slug: "aljouf", to: "/regions/aljouf", label: { ar: "الجوف", en: "Al-Jouf" } },
      { slug: "alula", to: "/regions/alula", label: { ar: "العلا", en: "AlUla" } },
      { slug: "bisha", to: "/regions/bisha", label: { ar: "بيشة", en: "Bisha" } },
    ],
  },
  {
    id: "culinary",
    to: "/culinary",
    label: { ar: "التراث الطهوي", en: "Culinary" },
    items: [
      { slug: "hinney", to: "/culinary/hinney", label: { ar: "حنيني", en: "Hinney" } },
      { slug: "klaitcha", to: "/culinary/klaitcha", label: { ar: "كليجة", en: "Klaitcha" } },
      { slug: "maamoul", to: "/culinary/maamoul", label: { ar: "معمول", en: "Ma'amoul" } },
      { slug: "areekah", to: "/culinary/areekah", label: { ar: "عريكة", en: "Areekah" } },
      { slug: "masoub", to: "/culinary/masoub", label: { ar: "معصوب", en: "Ma'soub" } },
      { slug: "batheeth", to: "/culinary/batheeth", label: { ar: "بثيث", en: "Batheeth" } },
    ],
  },
  {
    id: "routes",
    to: "/routes",
    label: { ar: "طرق التجارة", en: "Trade Routes" },
    items: [
      { slug: "incense-route", to: "/routes/incense-route", label: { ar: "طريق البخور", en: "Incense Route" } },
      { slug: "darb-zubaidah", to: "/routes/darb-zubaidah", label: { ar: "درب زبيدة", en: "Darb Zubaidah" } },
    ],
  },
];

// Region landing pages (Phase 21) — slugs mirror map loc_ids
export const REGION_SLUGS = ["alahsa", "qassim", "madinah", "riyadh", "najran", "aljouf", "alula", "bisha"];

export const KIND_LABEL = {
  varieties: { ar: "أصناف التمور", en: "Varieties" },
  oases: { ar: "الواحات والمدن", en: "Oases & Cities" },
  regions: { ar: "مناطق التمور", en: "Date Regions" },
  culinary: { ar: "التراث الطهوي", en: "Culinary Heritage" },
  routes: { ar: "طرق التجارة", en: "Trade Routes" },
  stories: { ar: "حكايات التراث", en: "Heritage Stories" },
  gallery: { ar: "معرض التراث البصري", en: "Visual Heritage Gallery" },
};
